<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Appointment of Deputy Secretary
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <Form20SecretaryResolution :data="getCompanyDeputySecretary ? getCompanyDeputySecretary.data : null" badge="Current Deputy Secretary" particularsTitle="PARTICULARS OF DEPUTY SECRETARY"></Form20SecretaryResolution>
        </b-col>
        <b-col>
          <Form20SecretaryResolution :data="data" badge="New Deputy Secretary" particularsTitle="PARTICULARS OF DEPUTY SECRETARY"></Form20SecretaryResolution>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Form20SecretaryResolution from "@/views/home/services/continuous-filing/task/forms/Form20SecretaryResolution";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ChangeOfDeputySecretary",
  components: { Form20SecretaryResolution },
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanyDeputySecretary(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanyDeputySecretary"]),
  },
  computed:{
    ...mapGetters(["getCompanyDeputySecretary"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>

